function Icon(props) {
  const className = props.className ? `icon ${props.className}` : 'icon'
  const strokeWidth = props.strokeWidth ? props.strokeWidth : ''
  const style =
    props.color || props.style
      ? {
          ...(typeof props.style === 'object' && props.style !== null ? props.style : {}),
          ...(props.color ? { color: props.color } : {})
        }
      : undefined

  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox={props.viewBox} fill="none" style={style}>
      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#${props.name}`} x="0" y="0" strokeWidth={strokeWidth} />
    </svg>
  )
}

export default Icon
